'use client';

import { useState, Suspense } from 'react'
import { signIn } from "next-auth/react";
import { useSearchParams } from 'next/navigation'

function SignInContent() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const searchParams = useSearchParams()
  const callbackUrl = searchParams.get('callbackUrl') || '/'

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')

    try {
      const result = await signIn('credentials', {
        username,
        password,
        redirect: false,
      })

      if (result?.error) {
        setError('Invalid credentials')
      } else {
        // Fire log-login without awaiting — never block navigation on logging
        // fetch('/api/log-login', {
        //   method: 'POST',
        //   headers: {'Content-Type': 'application/json'},
        // }).catch(err => console.error('Failed to log login:', err));

        const hash = window.location.hash

        // Resolve callbackUrl to a relative path — router.push() silently
        // fails on absolute URLs, and the RSC cache can redirect back to
        // /login before the session cookie is recognised. window.location.href
        // forces a full browser navigation that sends the cookie correctly.
        const resolvedCallback = (() => {
          try {
            const url = new URL(callbackUrl) // throws if already relative
            return url.pathname + url.search + (hash && !url.hash ? hash : url.hash)
          } catch {
            return callbackUrl + (hash && !callbackUrl.includes('#') ? hash : '')
          }
        })()

        window.location.href = resolvedCallback
      }
    } catch (error) {
      setError('An error occurred during sign in')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="d-flex align-items-center justify-content-center w-100">
      <div className="row justify-content-center w-100">
        <div className="col-12 col-md-7 col-lg-5 col-xxl-3">
          <div className="my-4">
            <div className="px-lg-5 py-5">
              <div className="title text-center my-3">
              </div>
              <div className="text-center mt-5">
                <div className="mb-3">
                  <img src="/logo.png" alt="Keeneland Logo" style={{ width: "68px", height: "39px" }} />
                </div>
                <h1 className="h1 mb-2">
                  Log in
                </h1>
              </div>
              <hr />
              <form onSubmit={handleSubmit}>
                <div className="row g-2">
                  <div className="col-12">
                    <label htmlFor="inputEmail4" className="form-label">
                      Email Address or User ID
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="inputEmail4"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <label htmlFor="inputPassword4" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="inputPassword4"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>

                  {error && (
                    <div className="col-12">
                      <div className="alert alert-danger" role="alert">
                        {error}
                      </div>
                    </div>
                  )}

                  <div className="col-12 mt-3">
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={isLoading}
                      style={{ textTransform: 'none' }}
                    >
                      {isLoading ? 'Logging in...' : 'Log in'}
                    </button>
                  </div>
                </div>
              </form>

              <hr className='mb-3 mt-3' style={{ backgroundColor: 'var(--tertiary)', borderColor: 'var(--tertiary)', height: '0px' }}></hr>
              <div className="row justify-content-center">
                <div className="col-12 text-center">
                  <p className="text-gray mb-1 mt-0 small fw-bold">
                    Use your Keeneland sale system credentials to log in to the Health Document Parser.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function SignIn() {
  return (
    <Suspense fallback={<div className="container pt-5">Loading...</div>}>
      <SignInContent />
    </Suspense>
  );
}